module.exports = __webpack_public_path__ + "img/Billedbog_Litteraere_tekster_for_barn2.13701dd7.jpg";